import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import {
	CROSS_JOIN_NUDGE_PROJECT_GATE,
	CROSS_JOIN_NUDGE_PROJECT_EXPERIMENT,
} from '../../ui/cross-join/constants';
import { getTargetingGate, getExperimentValue } from '../../common/feature-gates';
import { AccessRequestCapabilityType } from '../../state/confluence/access-request-capabilities/types';
import { type Props } from './types';

const CROSS_JOIN_SCENARIOS = [
	{
		type: AccessRequestCapabilityType.DIRECT_ACCESS,
		analyticsName: 'join-product',
	},
	{
		type: AccessRequestCapabilityType.REQUEST_ACCESS,
		analyticsName: 'request-access',
	},
	{
		type: AccessRequestCapabilityType.PENDING_REQUEST_EXISTS,
		analyticsName: 'access-requested',
	},
	{
		type: AccessRequestCapabilityType.DENIED_REQUEST_EXISTS,
		analyticsName: 'access-denied',
	},
	{
		type: AccessRequestCapabilityType.APPROVED_REQUEST_EXISTS,
		analyticsName: 'access-revoked',
	},
	{
		type: AccessRequestCapabilityType.ERROR,
		analyticsName: 'error',
	},
];

const View = ({
	isSpaceConnected,
	confluenceEdition,
	jswEdition,
	accessRequestCapability,
	children,
}: Props) => {
	const crossJoinScenario = CROSS_JOIN_SCENARIOS.find(
		({ type }) => type === accessRequestCapability,
	)?.analyticsName;

	const isCrossJoinProjectExperimentEnabled = getTargetingGate(CROSS_JOIN_NUDGE_PROJECT_GATE);
	const crossJoinNudgeExperimentCohort = isCrossJoinProjectExperimentEnabled
		? getExperimentValue(CROSS_JOIN_NUDGE_PROJECT_EXPERIMENT, 'not-enrolled', false)
		: 'not-enrolled';

	return (
		<AnalyticsContext
			data={{
				attributes: {
					isSpaceConnected,
					isCrossJoinProjectExperimentEnabled,
					crossJoinNudgeExperimentCohort,
					crossJoinScenario,
					confluenceEdition,
					jswEdition,
				},
			}}
		>
			{children}
		</AnalyticsContext>
	);
};

export default View;
